import { initializeApp } from "firebase/app"
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithRedirect,
  signOut,
  AuthProvider,
  OAuthProvider,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from "firebase/auth"
import { queryClient } from "./react-query.ts"
import { usePermStore } from "./perm-store.ts"
import { resetUser, captureError } from "./log.ts"

const firebaseConfig = {
  apiKey: "AIzaSyD_3jKf8Y4HT6iNZQHTX2AhwWWlCkzFQ6s",
  authDomain: "pillars-73a91.firebaseapp.com",
  projectId: "pillars-73a91",
  storageBucket: "pillars-73a91.appspot.com",
  messagingSenderId: "1007998010623",
  appId: "1:1007998010623:web:a7bc24c1b89ca0ef5938ca",
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)

export function loginWithGoogle() {
  const provider = new GoogleAuthProvider()
  signInWithPopup(auth, provider)
}

export function loginWithApple() {
  const provider = new OAuthProvider("apple.com")
  provider.addScope("email")
  provider.addScope("name")
  signInWithPopup(auth, provider)
}

const PENDING_EMAIL_KEY = "pendingLoginEmail"

export async function sendLoginEmail(email: string) {
  const url = `${window.location.origin}/`
  await sendSignInLinkToEmail(auth, email, {
    url,
    handleCodeInApp: true,
  })
  window.localStorage.setItem(PENDING_EMAIL_KEY, email)
}

let emailLinkHandled = false
export async function completeEmailLoginIfPresent(): Promise<
  { status: "none" } | { status: "success" } | { status: "error"; error: unknown }
> {
  if (emailLinkHandled) return { status: "none" }
  if (!isSignInWithEmailLink(auth, window.location.href)) return { status: "none" }
  emailLinkHandled = true

  let email = window.localStorage.getItem(PENDING_EMAIL_KEY)
  if (!email) {
    email = window.prompt("Please confirm the email you used to request the link") || ""
  }

  try {
    await signInWithEmailLink(auth, email, window.location.href)
    return { status: "success" }
  } catch (error) {
    captureError(error, { tags: { source: "completeEmailLogin" } })
    return { status: "error", error }
  } finally {
    window.localStorage.removeItem(PENDING_EMAIL_KEY)
    const cleanUrl = window.location.origin + window.location.pathname
    window.history.replaceState({}, "", cleanUrl)
  }
}

export async function logout() {
  try {
    await signOut(auth)
  } catch (error) {
    captureError(error, { tags: { source: "logout" } })
  }
  resetUser()
  queryClient.clear()

  const { setPermStore } = usePermStore.getState()
  setPermStore({
    emulateUserId: undefined,
  })
}

// eslint-disable-next-line
;(window as any).getToken = async () => {
  const token = await auth.currentUser?.getIdToken()
  console.log(token)
}
